



























import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Tab extends Vue {
  @Prop()
  tabList!: any;

  TabFix = false;
  active = 0;
  offsetTop = 700;
  activeEnd = false;
  flag = true;
  arrDom;
  ele;

  mounted() {
    //记录每个内容对应的dom数组

    this.arrDom = document.getElementsByClassName("TabContent");
    this.ele = document.querySelector(".TabChange");
    window.addEventListener("scroll", this.handleScroll);
  }
  // 鼠标进入tab_box上时
  mouseOver() {
    this.flag = false;
  }
  //鼠标离开tab_box上时
  mouseLeave() {
    this.flag = true;
  }
  // 判断当前浏览器是不是ie
  isIE() {
    //ie?
    if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
    else return false;
  }

  // 鼠标切换tab的li时
  mousetabOver(i) {
    this.active = i + 1;
    const bodyWidth = document.body.clientWidth;
    if (this.arrDom[i]) {
      // 判断当前tab有没有吸顶
      if (this.ele.getBoundingClientRect().top == 0) {
        if (this.isIE()) {
          window.scrollTo(0, this.arrDom[i].offsetTop - 80);
        } else {
          window.scrollTo({
            top: this.arrDom[i].offsetTop - 80,
            behavior: "smooth"
          });
        }
      } else {
        // console.log(bodyWidth);
        if (bodyWidth < 376) {
          window.scrollTo({
            top: this.arrDom[i].offsetTop - 80,
            behavior: "smooth"
          });
        } else if (this.isIE()) {
          window.scrollTo(0, this.arrDom[i].offsetTop - 190);
        } else {
          window.scrollTo({
            top: this.arrDom[i].offsetTop - 190,
            behavior: "smooth"
          });
        }
      }
    }
  }
  handleScroll(e) {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.TabFix = scrollTop > this.offsetTop - 100;
    if (this.flag) {
      for (let i = 0; i < this.arrDom.length; i++) {
        //因为下面使用到了i+1，所以需要把最后一个分离出来判断
        if (this.arrDom[this.arrDom.length - 1].offsetTop - scrollTop > 100) {
          if (
            this.arrDom[i].offsetTop - scrollTop <= 100 &&
            this.arrDom[i + 1].offsetTop - scrollTop > 100
          ) {
            this.active = i + 1;
          }
        } else {
          this.active = this.arrDom.length;
          // this.active = i + 1;
        }
      }
    }
  }
}
